var map = {
	"./akpo.jpg": "./src/assets/fpso/akpo.jpg",
	"./alima.jpg": "./src/assets/fpso/alima.jpg",
	"./antwerp tera.jpg": "./src/assets/fpso/antwerp tera.jpg",
	"./base industrielle.jpg": "./src/assets/fpso/base industrielle.jpg",
	"./carling.jpg": "./src/assets/fpso/carling.jpg",
	"./clov.jpg": "./src/assets/fpso/clov.jpg",
	"./dalia.jpg": "./src/assets/fpso/dalia.jpg",
	"./dan.jpg": "./src/assets/fpso/dan.jpg",
	"./djeno.jpg": "./src/assets/fpso/djeno.jpg",
	"./donges.jpg": "./src/assets/fpso/donges.jpg",
	"./egina.jpg": "./src/assets/fpso/egina.jpg",
	"./feluy.jpg": "./src/assets/fpso/feluy.jpg",
	"./feyzin.jpg": "./src/assets/fpso/feyzin.jpg",
	"./girassol.jpg": "./src/assets/fpso/girassol.jpg",
	"./gorm.jpg": "./src/assets/fpso/gorm.jpg",
	"./halfdan a.jpg": "./src/assets/fpso/halfdan a.jpg",
	"./halfdan b.jpg": "./src/assets/fpso/halfdan b.jpg",
	"./halfdan.jpg": "./src/assets/fpso/halfdan.jpg",
	"./harald.jpg": "./src/assets/fpso/harald.jpg",
	"./k6cc.jpg": "./src/assets/fpso/k6cc.jpg",
	"./kaombo norte.jpg": "./src/assets/fpso/kaombo norte.jpg",
	"./kaombo sul.jpg": "./src/assets/fpso/kaombo sul.jpg",
	"./moho nord.jpg": "./src/assets/fpso/moho nord.jpg",
	"./neuquen.jpg": "./src/assets/fpso/neuquen.jpg",
	"./nkossa.jpg": "./src/assets/fpso/nkossa.jpg",
	"./normandie.jpg": "./src/assets/fpso/normandie.jpg",
	"./pazflor.jpg": "./src/assets/fpso/pazflor.jpg",
	"./pngf nord.jpg": "./src/assets/fpso/pngf nord.jpg",
	"./port arthur.jpg": "./src/assets/fpso/port arthur.jpg",
	"./skjold.jpg": "./src/assets/fpso/skjold.jpg",
	"./tierra del fuego.jpg": "./src/assets/fpso/tierra del fuego.jpg",
	"./tyra.jpg": "./src/assets/fpso/tyra.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/fpso sync recursive ^\\.\\/.*\\.jpg$";